import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../language.service';

@Component({
  selector: 'app-language',
  template: `
  <button mat-button disableRipple="true"><mat-icon>
  <img id="language-icon" mat-icon-button [src]="img.url" style="width: inherit;transform: scale(3); vertical-align: baseline;" (click)="changeLang()">
  </mat-icon></button>`
})
export class LanguageComponent implements OnInit {

  constructor(
    private translate: TranslateService,
    private languageService: LanguageService) { }

  public images: Array<any> = [
    { url: '../../assets/img/language-eng.png', text: 'English' },
    { url: '../../assets/img/language-gr.png', text: 'Greek' }
  ];

  public img: any;
  private language_used;
  private language_next;

  ngOnInit() {
    this.languageService.currentLanguage.subscribe(message => {
      if (message == 'en') {
        this.language_used = 'EN'
        this.language_next = 'EL'
        this.img = this.images[1];
        this.translate.use('en')
      }
      else {
        this.language_used = 'EL'
        this.language_next = 'EN'
        this.img = this.images[0];
        this.translate.use('el')
      }
    })
  }

  changeLang() {
    if (this.img.url === this.images[0].url) {
      this.img = this.images[1];
    } else {
      this.img = this.images[0];
    }

    if (this.language_used == 'EN') {
      this.translate.use('el')
      this.language_used = 'EL'
      this.language_next = 'EN'

      this.languageService.changeLanguageService('el')
    }
    else {
      this.translate.use('en')
      this.language_used = 'EN'
      this.language_next = 'EL'
      this.languageService.changeLanguageService('en')
    }
  }

}
